module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04-m-jp.b96c23626374fe97fd7832881be25c93.png";